import React from 'react'

import ErrorLayout from '@Pages/error/layout'
import { ReactLazyPreload } from '@Components/utils/RouterUtils'
import { LAND_COMMON_URL } from '@Root/contants/urlConstants'

const ErrorPage = ReactLazyPreload(() => import(/* webpackChunkName: 'Error' */ './error'))
const MaintenancePage = ReactLazyPreload(() => import(/* webpackChunkName: 'Maintenance' */ './maintenance'))
const NotFoundPage = ReactLazyPreload(() => import(/* webpackChunkName: 'NotFound' */ './notfound'))

export default {
  layout: ErrorLayout,
  routes: [
    {
      path: LAND_COMMON_URL.ERROR,
      exact: true,
      component: ErrorPage,
    },
    {
      path: LAND_COMMON_URL.MAINTENANCE,
      exact: true,
      component: MaintenancePage,
    },
    {
      path: [LAND_COMMON_URL.NOT_FOUND, '*'],
      exact: false,
      component: NotFoundPage,
    },
  ],
}
